import {v4 as uuidv4} from 'uuid';
import {flowchartNodeType} from '../../../util/uiconstants';

const calculateNewChart = (parentId, latestChart) => {
	const nodes = latestChart.nodes;
	const parentColumnNodes = nodes
		.filter((node) => {
			if (node.parentId === parentId) {
				return node;
			}
		})
		.sort((a, b) => {
			return a.position.y - b.position.y;
		});

	const yPosition = parentColumnNodes[parentColumnNodes.length - 1].position.y + 200;

	const parentTotalHeight = nodes.filter((node) => node.id === parentId)[0].style.height;
	const nodesTotalHeight = parentColumnNodes.reduce((accum, currentValue) => accum + currentValue.position.y, 0);

	let newParents = [];
	if (parentTotalHeight <= nodesTotalHeight) {
		const updateParentHeight = structuredClone(nodes.filter((node) => node.type === flowchartNodeType.flowChartColumn));

		updateParentHeight.forEach((parent) => {
			parent.style.height = parent.style.height + 300;
		});
		const allNodes = nodes.filter((node) => node.type !== flowchartNodeType.flowChartColumn);
		newParents = [...updateParentHeight, ...allNodes];
	}
	const newGuid = uuidv4();
	const newNode = {
		id: `${newGuid}`,
		type: flowchartNodeType.flowChartStep,
		data: {title: 'NEW NODE', description: 'Description'},
		position: {x: 100, y: yPosition},
		parentId: parentId
	};

	if (newParents.length) {
		return {...latestChart, nodes: [...newParents, newNode]};
	} else {
		return {...latestChart, nodes: [...nodes, newNode]};
	}
};
export default calculateNewChart;
